export const backgroundCount = {
  start: 0,
  end: 3,
};

export const roomAvailableStates = ['main', 'procedureGame', 'customization'];
